import {
  basePath
 } from '../common/path'
 
 
 const path = {
  templateEmployee: `/v2${basePath.concat('/master-user-template')}`,
 }

 export { path }